import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IGetProvidersResponse } from '../../../entity/interface/iGetProviders';

export interface IGetProvidersUseCase {
    execute(dataSources: string): Promise<IGetProvidersResponse>;
}

export class GetProvidersUseCase implements IGetProvidersUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(dataSources: string): Promise<IGetProvidersResponse> {
        const response = await this.customConfigurationRepository.getProviders(dataSources);
        return response;
    }
}
